import React, { useState, useEffect } from "react";
import SignIn from "./SignIn"
import * as userApi from "../../apiService";
import { useHistory } from "react-router-dom";

function UserLoginPage(props) {
    let history = useHistory();
    const [register, setRegister] = useState({ isRegistering: props.register })

    const [user, setUser] = useState({
        name: "",
        email: "",
        password: ""
    });

    function cleanFields(){
        setUser({
            name: "",
            email: "",
            password: ""
        })
    }
    useEffect(() => {
        cleanFields()
    }, [props]);

    function handleUserLogin(event) {
       
        event.preventDefault();
        userApi.loginUser(user).then((data) => {
            history.push("/home");
        }).catch((data)=>{ alert("couldnt login please try again later")})
    }

    function handleChange({ target }) {
        setUser({
            ...user,
            [target.name]: target.value
        });
    }
        return (
            <>
                <SignIn user={user} sx={{marginTop:30 }}
                    handleSignIn={handleUserLogin} 
                    onChange={handleChange} 
                    onUserLogin={handleUserLogin}></SignIn>
            </>
        );
    
}
export default UserLoginPage;

